module.exports = __webpack_public_path__ + "img/1.930b2a6f.png";